React = require 'react'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
{ Storage } = require '@trello/storage'
t = require('app/scripts/views/internal/recup-with-helpers')()
{ StickyBoxWaitForMount } = require 'app/common/components/sticky-box-wait-for-mount'
{ HomeLeftSidebarContainer } = require './presentational/HomeLeftSidebarContainer'
HomeMainContentContainer = require 'app/scripts/views/home/home-main-content-container'
HomeRightSidebarContainer = require 'app/scripts/views/home/home-right-sidebar-container'

module.exports = class HomeContainer extends React.Component
  displayName: 'HomeContainer'

  constructor: (props) ->
    super props

  render: t.renderable ->
    { modelCache, model, orgname, allBoards, orgBoards, setFocusedCard, templates, templateCategory } = @props

    t.div '.home-container', =>
      t.div '.home-sticky-container', =>
        t.tag StickyBoxWaitForMount, =>
          t.tag HomeLeftSidebarContainer, {
            modelCache
            model
            orgname
            allBoards
            orgBoards
            templateCategory
            templates: Boolean(templates)
          }
        if allBoards
          t.div '.all-boards', ->
            t.tag StickyBoxWaitForMount, =>
              t.div '.content-all-boards', =>
                allBoards()
        else if orgBoards
          t.div '.all-boards', =>
            t.tag StickyBoxWaitForMount, =>
              t.div '.content-all-boards', =>
                orgBoards()
        else if templates
          t.div '.all-boards', =>
            t.tag StickyBoxWaitForMount, =>
              t.div '.content-all-boards', =>
                templates()
        else
          t.tag HomeMainContentContainer, {
            modelCache
            orgname
            setFocusedCard
          }
          t.tag StickyBoxWaitForMount, =>
            t.tag HomeRightSidebarContainer, {
              modelCache
              model
              orgname
            }
